import React, { useState } from "react";
import PropTypes from "prop-types";
import plus from "../assets/Plus.png";
import minus from "../assets/Minus.png";
import styles from "./AddButton.module.css";

const AddButton = ({ onClick, isPlus = true }) => {
  const [isAdding, setIsAdding] = useState(isPlus);

  const handleClick = () => {
    // setIsAdding((prev) => !prev);
    if (onClick) {
      onClick(isAdding);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={styles.button}
      aria-label={isAdding ? "Add" : "Remove"}
    >
      <img src={isAdding ? plus : minus} alt={isAdding ? "Add" : "Remove"} />
    </button>
  );
};

AddButton.propTypes = {
  onClick: PropTypes.func,
  isPlus: PropTypes.bool, // New prop to determine starting state
};

export default AddButton;
